import { Box, ListItem, Link as UiLink } from '@mui/material';

type TableOfContentItem = {
  title: string;
  target: string;
  isNumberList?: boolean;
  itemIndex?: number;
  isActiveItem?: boolean;
  setActiveItem: () => void;
};

export function TableOfContentItem({
  title,
  target,
  isNumberList = false,
  itemIndex = 0,
  isActiveItem = false,
  setActiveItem,
}: TableOfContentItem) {
  return (
    <ListItem sx={{ padding: 0 }}>
      <UiLink href={`#${target}`} onClick={() => setActiveItem()} sx={{ width: '100%' }}>
        <Box
          sx={{
            cursor: 'pointer',
            borderLeft: '2px solid',
            borderColor: isActiveItem ? 'blues.lighter' : 'neutral.lighter',
            backgroundColor: isActiveItem ? 'secondary.light' : 'transparent',
            paddingY: 2,
            paddingLeft: 3,
            display: 'flex',
            flexDirection: 'column',

            '&:hover': {
              backgroundColor: { sm: 'secondary.light' },
              borderColor: 'blues.lighter',
            },
            '&:active': {
              borderColor: 'secondary.main',
            },
          }}
        >
          {isNumberList && itemIndex ? <Box component="span">{itemIndex}.</Box> : null}
          <Box component="span" sx={{ fontWeight: isActiveItem ? 700 : 400 }}>
            {title}
          </Box>
        </Box>
      </UiLink>
    </ListItem>
  );
}
